import { AspectContext } from '@lib.core/entities/indicator/indicator-context';
import { AspectDimensions } from '@lib.core/entities/indicator/indicator';
import { AspectDatapoint } from '@lib.core/entities/indicator/indicator-datapoint';

export class AspectDatapointDTO {
  factNameid!: string;
  year!: number;
  month?: number;
  context!: AspectContext;
  dimensions!: AspectDimensions;
  value!: number;

  static toAspectDatapoint(aspectDatapointDTO: AspectDatapointDTO): AspectDatapoint {
    const { factNameid, year, month, context, dimensions, value } = aspectDatapointDTO;
    return new AspectDatapoint(
      factNameid,
      year,
      month,
      context,
      dimensions,
      value
    );
  }
}

export class AspectDataAvailabilityDTO {
  isDataAvailable!: boolean;

  static toIsDataAvailable(dto: AspectDataAvailabilityDTO): boolean {
    return dto.isDataAvailable;
  }
}
